import axios from "axios";
import * as ROUTES from "../../../constants/routes";
import Helpers from "../../Helpers";

export default class AddUserFunction {
  constructor() {
    this.helpers = new Helpers();
  }

  doDeletetUser = (userId) => {
    const token = this.helpers.getCookie("token");
    return new Promise((resolve, reject) => {
      axios
        .post(
          ROUTES.FUNCTIONAL_BASE_URL + "cms-admin/delete",
          JSON.stringify({
            useruid: userId,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          this.helpers.handleError(err);
          reject(err);
        });
    });
  };
}
